import { Link } from "react-router-dom";
import { useAuthStore } from "../lib/auth";

export default function SettingsPage() {
  const email = useAuthStore((s) => s.email);
  const signOut = useAuthStore((s) => s.signOut);

  return (
    <main className="min-h-screen bg-washi px-6 py-10">
      <div className="mx-auto max-w-3xl">
        <Link to="/cards" className="text-sm text-navySoft hover:underline">
          ← 一覧に戻る
        </Link>
        <h2 className="serif mt-4 text-2xl font-medium text-navy">設定</h2>

        <dl className="mt-8 grid gap-4 text-sm">
          <div>
            <dt className="font-medium text-navy">接続中の Google アカウント</dt>
            <dd className="mt-1 text-navySoft">{email ?? "(未取得)"}</dd>
          </div>
          <div>
            <dt className="font-medium text-navy">スプレッドシート</dt>
            <dd className="mt-1 text-navySoft">(Day 2 で実装) 自動検出されたシートを表示</dd>
          </div>
        </dl>

        <div className="mt-12">
          <button type="button" onClick={signOut} className="btn-primary">
            ログアウト
          </button>
        </div>

        <div className="mt-12 flex flex-col gap-2 text-xs text-inkLight">
          <a href="https://tsubamecard.com/privacy.html" className="hover:underline">
            プライバシーポリシー
          </a>
          <a href="https://tsubamecard.com/terms.html" className="hover:underline">
            利用規約
          </a>
          <a href="mailto:support@tsubamecard.com" className="hover:underline">
            サポートに連絡
          </a>
        </div>
      </div>
    </main>
  );
}
